// LR chain values as the sidebar reads them: `a-b#v;…` (step), `a#v;…` (bare offsets:
// linear points, spots, or step sections whose end is the next start). Pure, so the
// node tests reach it. The LR SDK stays the authority for values at a position; this
// only exposes the sections so they can be listed and drawn.

const SECTION = /^(\d+)(?:-(\d*))?#(.*)$/s;
const LR_SUFFIX = /:(step|linear|spot)$/;

/**
 * Split on `separator`, where a backslash before it makes it a literal character.
 * @param {string} text
 * @param {string} separator one character
 * @returns {string[]}
 */
export function splitUnescaped(text, separator) {
  const parts = [];
  let current = "";
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    if (char === "\\" && text[i + 1] === separator) {
      current += separator;
      i++;
    } else if (char === separator) {
      parts.push(current);
      current = "";
    } else {
      current += char;
    }
  }
  parts.push(current);
  return parts;
}

/**
 * @param {string} key
 * @returns {"step"|"linear"|"spot"|null}
 */
export function lrKindOfKey(key) {
  const match = LR_SUFFIX.exec(key);
  return match ? match[1] : null;
}

/**
 * @param {string} key
 * @returns {string} the key without its `:step` / `:linear` / `:spot` suffix
 */
export function baseKey(key) {
  return key.replace(LR_SUFFIX, "");
}

/**
 * Sections of an LR chain, or null when any `;` part is not `start[-[end]]#value`.
 * A bare offset (`1100#x`) and an empty end (`1000-#no`) give `endCm: null`.
 * @param {unknown} value
 * @returns {{startCm: number, endCm: number|null, value: string}[]|null}
 */
export function parseLrChain(value) {
  if (typeof value !== "string" || value === "") return null;
  const sections = [];
  for (const part of splitUnescaped(value, ";")) {
    const match = SECTION.exec(part);
    if (!match) return null;
    sections.push({
      startCm: Number(match[1]),
      endCm: match[2] ? Number(match[2]) : null,
      value: match[3],
    });
  }
  return sections;
}
